<div class="page-footer">
    <div class="page-copyright">
        <img src="assets/justmejt_copyright.png" alt="copyright logo"/>
    </div>
</div>
